/**
 * Trunnion AI - Auth Store
 * Manages authentication state: user, token, and clearance context.
 */

import { create } from 'zustand';
import { TOKEN_STORAGE_KEY } from '@/config/constants';
import type { Operator, ClearanceContext } from '@/types';

interface AuthState {
  user: Operator | null;
  token: string | null;
  clearanceContext: ClearanceContext | null;
  isAuthenticated: boolean;

  setAuth: (user: Operator, token: string, clearance: ClearanceContext) => void;
  clearAuth: () => void;
  updateClearanceContext: (clearance: ClearanceContext) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: localStorage.getItem(TOKEN_STORAGE_KEY),
  clearanceContext: null,
  isAuthenticated: !!localStorage.getItem(TOKEN_STORAGE_KEY),

  setAuth: (user, token, clearanceContext) =>
    set({
      user,
      token,
      clearanceContext,
      isAuthenticated: true,
    }),

  clearAuth: () =>
    set({
      user: null,
      token: null,
      clearanceContext: null,
      isAuthenticated: false,
    }),

  updateClearanceContext: (clearanceContext) =>
    set({ clearanceContext }),
}));
